var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFavoriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icn-favorite-filled_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icn-favorite-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.517 15.86a1.373 1.373 0 01-.433-.27l-.99-.9c-1.518-1.348-2.844-2.65-3.977-3.908s-1.7-2.588-1.7-3.99c0-1.1.378-2.02 1.134-2.762.756-.742 1.69-1.113 2.803-1.113.645 0 1.284.148 1.919.444.634.296 1.21.8 1.727 1.51.545-.71 1.128-1.214 1.749-1.51a4.367 4.367 0 011.897-.444c1.113 0 2.048.371 2.804 1.113.756.742 1.134 1.663 1.134 2.762 0 1.418-.58 2.76-1.74 4.026a55.387 55.387 0 01-3.938 3.863l-.997.91a1.359 1.359 0 01-.437.27 1.375 1.375 0 01-.955 0z",
    fill: "#FF7D6B"
  }))));
}
export default SvgIcnFavoriteFilled;